module.exports = __webpack_public_path__ + "static/media/illustration-behavior-dog.58eb5478.svg";